import { Suspense } from 'react';
import { ToolLoader } from 'shared/components/Loader';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './components/App';
import { InternalServerError } from 'shared/components';
import {BugsnagConfigProvider, ErrorBoundary} from '@dnhb/functional-component';

const apiKey = process.env.BUGSNAG_JS_API_KEY;

const Root = () => (
  <BugsnagConfigProvider bugsnagApiKey={apiKey}>
    <ErrorBoundary fallbackComponent={InternalServerError}>
      <Suspense fallback={<ToolLoader />}>
        <BrowserRouter>
          <Provider store={store}>
            <App />
          </Provider>
        </BrowserRouter>
      </Suspense>
    </ErrorBoundary>
  </BugsnagConfigProvider>
);


export default Root;
